import { render, staticRenderFns } from "./CertificateLookupDetail.vue?vue&type=template&id=29605596&scoped=true"
import script from "./CertificateLookupDetail.vue?vue&type=script&lang=js"
export * from "./CertificateLookupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29605596",
  null
  
)

export default component.exports